require('./assets/sass/reset.scss')
require('./assets/sass/global-consult.scss')
require('./assets/sass/global-question.scss')
require('./assets/iconfont/style.css')
require('./assets/iconfont/yxl-font.css')
require('./assets/iconfont_ali/iconfont.css')
require('./assets/style/swipe.css')
require('./assets/sass/toast.scss')

import 'babel-polyfill'
import 'url-search-params-polyfill'

if (process.env.NODE_ENV === 'development') {
  const vconsole = require('vconsole')
  new vconsole()
}

// 埋点
import statPlugin from 'src/frontend-lib/mixins/statPlugin'

import './libs/flexible'
import './libs/toast'

import Vue from 'vue'
// import Vuex from 'vuex'

import vueTap from 'v-tap'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueTouch from 'vue-touch'
import dialog from './modules/dialog'
import directives from './units/directivesPlugin'

// import modal from './modules/modal'

// $toast $loading $success $fail
import toast from './modules/toast'
import { getRunTime, getMP } from '../src/libs/utils'
import { getPlatform, getRunningEnv } from 'src/frontend-lib/tools/getPlatform'
import { getRequestSign } from 'src/frontend-lib/tools/platformSign'
import { getUrlParams } from 'src/frontend-lib/tools/url'
import router from './router/index'

// import store from './store/store'
import {
  isCanHideNavigationBar,
  wxConfigOrigin
} from 'src/frontend-lib/tools/utils.js'
import axios from 'axios'

//set wechat title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.use(vueTap)
Vue.use(VueTouch)
Vue.use(VueAwesomeSwiper)
Vue.use(dialog)
Vue.use(directives)

// Vue.use(modal)

Vue.use(toast)

// window.yxl = {
//   stat: new Stat()
// }
Vue.use(statPlugin, {})
// window.yxl.stat.init({ bridge: new Bridge() });

// window.jsRefreshWebviewAsync = new Promise((resolve, reject) => {
//   window.jsRefreshWebviewResolve = () => {
//     resolve()
//   }
// })
// window.jsRefreshWebview = data => {
//   window.jsRefreshWebviewResolve(data)
// }
Vue.prototype.$getMP = window.$getMP = getMP()

// 冥想星球小程序不要带上cookie
axios.defaults.withCredentials = !(
  getUrlParams({
    type: 'hash',
    params: ['channelId']
  }).channelId *
    1 ===
    2147 && getMP()
)

let runtime = getRunTime('//m.xinli001.com')

var ua = window.navigator.userAgent
var isApp =
  ua.toLocaleLowerCase().indexOf('yixinliapp') > -1 ||
  /(?:yixinliConsultationApp)/.test(ua)

axios.interceptors.request.use(
  config => {
    let _token = localStorage.getItem('token') || ''
    //config.headers['Website-Token'] = _token || null ;
    if (_token && isApp) {
      if (config.url.indexOf('?') === -1) {
        config.url = config.url + '?token=' + _token
      } else {
        config.url = config.url + '&token=' + _token
      }
      // 重新签名
      if (config.params && config.params.sign) {
        delete config.params.sign
        config.params.token = _token
        let { sign, params } = getRequestSign(config.params)
        params.sign = sign
        config.params = params
      }
    }

    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// 针对40001未登录错误做统一处理
axios.interceptors.response.use(
  res => {
    /**
     * 后端未登录错误码有可能是40001 40002,但是40002部分是 “用户行为拦截”，比如阻止多次评论等
     * post(url, postdata, {
        disabledUnLoginInterceptors: true
      })
     * get(APIs.list, {
        params,
        disabledUnLoginInterceptors: true
      })
     */
    if (res.config.disabledUnLoginInterceptors === true) {
      return res
    }
    if (+res.data.code === 40001 || +res.data.code === 40002) {
      let UA = navigator.userAgent
      if (
        UA.indexOf('yixinliApp') >= 0 ||
        UA.indexOf('yixinliConsultationApp') >= 0
      ) {
        window.location.href = 'yixinli://open_user_login'
      } else {
        window.location.href = `${runtime}/account/login?next=${encodeURIComponent(
          window.location.href
        )}`
      }
      // localStorage.removeItem("token");
    }
    // 如果是kc接口且是302就重定向
    if (+res.data.code === 302 && res.config.url.indexOf('//kc') >= 0) {
      if (res.data.data) {
        window.location.href = res.data.data
      }
    }
    return res
  },
  err => {
    return Promise.reject(err)
  }
)

Vue.prototype.$http = axios

Vue.prototype.runningEnv = getRunningEnv()
Vue.prototype.platform = window.platform = getPlatform()
Vue.prototype.pcSite = getRunTime('//www.xinli001.com/')
Vue.prototype.mobileSite = getRunTime('//m.xinli001.com/')
Vue.prototype.$mSafeOrigin = wxConfigOrigin(
  require('../yxlConfig.json'),
  'XY_ORIGIN',
  'm_safe'
)
Vue.prototype.$sSafeOrigin = wxConfigOrigin(
  require('../yxlConfig.json'),
  'XY_ORIGIN',
  's_safe'
)
Vue.prototype.$mWranOrigin = wxConfigOrigin(
  require('../yxlConfig.json'),
  'XY_ORIGIN',
  'm_warn'
)
Vue.prototype.$sWranOrigin = wxConfigOrigin(
  require('../yxlConfig.json'),
  'XY_ORIGIN',
  's_warn'
)
Vue.prototype.staticSite =
  location.protocol + '//' + location.host + location.pathname
Vue.prototype.canHideNavigationBar = isCanHideNavigationBar(window.platform)

Vue.prototype.mobileSiteMap = {
  prod: '//m.xinli001.com/',
  qc: '//m-qc1.xinli001.com/'
}

document.location.host.indexOf('qc') > -1
  ? (Vue.prototype.env = 'qc')
  : (Vue.prototype.env = 'prod')

if (window.platform.isYixinliApp) {
  let appHookInit = require('src/libs/appHooks')
  appHookInit()
}

import index from './App'

new Vue({
  router,
  template: '<index></index>',
  components: {
    index
  }
  // store
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js